import React from "react";
import MarketProduct from "./MarketProduct";

import s from "./MarketProductsList.module.scss";

export default function MarketProductsList({ products = [] }) {
	return (
		<div className={s.root}>
			{products.map((product, index) => (
				<MarketProduct product={product} key={index} />
			))}
		</div>
	);
}
